import { render, staticRenderFns } from "./PasswordResetting.vue?vue&type=template&id=e73cc938&scoped=true&"
import script from "./PasswordResetting.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetting.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetting.vue?vue&type=style&index=0&id=e73cc938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73cc938",
  null
  
)

export default component.exports